function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
export const BadgeColors = {
  error: '#CE351D',
  success: '#54C418',
  primary: '#2288DA',
  warning: '#FBAC15'
};
export const Badge = ({
  containerStyle,
  textStyle,
  textProps,
  badgeStyle,
  onPress,
  value,
  status = 'primary',
  ...attributes
}) => {
  const Component = onPress ? TouchableOpacity : View;
  return /*#__PURE__*/React.createElement(View, {
    style: containerStyle
  }, /*#__PURE__*/React.createElement(Component, _extends({}, attributes, {
    style: [styles.baseBadgeStyle, {
      backgroundColor: BadgeColors[status]
    }, !value && styles.miniBadge, badgeStyle],
    onPress: onPress
  }), /*#__PURE__*/React.createElement(Text, _extends({
    style: [styles.text, textStyle]
  }, textProps), value)));
};
const size = 18;
const miniSize = 10;
const styles = StyleSheet.create({
  miniBadge: {
    paddingHorizontal: 0,
    paddingVertical: 0,
    minWidth: miniSize,
    height: miniSize,
    borderRadius: miniSize / 2
  },
  baseBadgeStyle: {
    alignSelf: 'center',
    minWidth: size,
    height: size,
    borderRadius: size / 2,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: '#fff'
  },
  text: {
    fontSize: 12,
    color: 'white',
    paddingHorizontal: 4
  }
});
//# sourceMappingURL=index.js.map